import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get notFoundParam() {
    return "allow_not_found"
  }

  connect() {
    const currentUrl = this.#currentUrl()
    const queryParams = this.#currentQueryParams()
    if (queryParams.get(this.constructor.notFoundParam)) {
      queryParams.delete(this.constructor.notFoundParam)
      currentUrl.search = queryParams
      window.history.replaceState({}, document.title, currentUrl.toString())
    }
  }

  updateBrancheUrl(event) {
    event.preventDefault()
    const targetUrl = event.currentTarget.href

    // Build target branch URL keeping current node path, current hash
    // and current query params. Add a `allow_not_found=true`
    // param to detect we are doing a switch of branch in the backend.
    const fullTargetUrl = new URL(targetUrl + this.#currentPath())
    fullTargetUrl.hash = this.#currentHash()
    fullTargetUrl.search = this.#targetQueryParams()

    // Change window location and follow the link
    window.location.href = fullTargetUrl
  }

  #rootUrl() {
    const rootUrl = new URL(document.body.dataset.docRootUrl)
    rootUrl.hash = ""
    rootUrl.search = ""

    return rootUrl
  }

  // Read internal path from currentUrl (by substracting the absolute
  // root base URL)
  #currentPath() {
    const currentUrl = this.#currentUrl()
    currentUrl.hash = ""
    currentUrl.search = ""
    const rootUrlWithoutTrailingDelimiter = this.#rootUrl().toString().replace(/\/$/, "")

    return currentUrl.toString().substring(rootUrlWithoutTrailingDelimiter.length)
  }

  #currentUrl() {
    return new URL(window.location.href)
  }

  #currentQueryParams() {
    return new URLSearchParams(this.#currentUrl().search)
  }

  #targetQueryParams() {
    const targetQueryParams = this.#currentQueryParams()
    targetQueryParams.append(this.constructor.notFoundParam, true)
    return targetQueryParams
  }

  #currentHash() {
    return this.#currentUrl().hash
  }
}
